// check if current path is /auth/*
export const isAuthPage = ({ route }) => {
    if( route.path.indexOf('/auth') !== -1)
        return true;
    
    if( route.path.indexOf('/login') !== -1)
        return true;

    if( route.path.indexOf('/register') !== -1)
        return true;

    if( route.path.indexOf('/reset/') !== -1)
        return true;

    if( route.path.indexOf('/verification') !== -1)
        return true;

    if( route.path.indexOf('/lms/login') !== -1)
        return true;

    if( route.path.indexOf('/lms/user_choice') !== -1)
        return true;

    if( route.path.indexOf('/lms/user_license') !== -1)
        return true;

    if( route.path.indexOf('/lms/user_entity_license') !== -1)
        return true;

    if( route.path.indexOf('/lms/confirmation') !== -1)
        return true;

    return false;

}

// check if navigation should be displayed
// if route.path does not exist yet returns false
export const shouldShowNavigation = ({ route }, getters) => (route.path ? !getters.isAuthPage : false);




// WEBPACK FOOTER //
// ./src/store/getters.js